export function clampPosterUnit(value: number) {
  return Math.min(1, Math.max(0, value))
}

/**
 * Shared poster cover math. Web adapters can add CSS-only fields around this.
 */
export function getPosterImageFrame(
  imageWidth: number | null,
  imageHeight: number | null,
  containerWidth: number,
  containerHeight: number,
  focalPointX: number,
  focalPointY: number,
  focalScale: number = 1
) {
  if (!imageWidth || !imageHeight || !containerWidth || !containerHeight) {
    return null
  }

  const coverScale = Math.max(containerWidth / imageWidth, containerHeight / imageHeight)
  const renderScale = coverScale * Math.max(1, focalScale)
  const width = imageWidth * renderScale
  const height = imageHeight * renderScale
  const overflowX = Math.max(0, width - containerWidth)
  const overflowY = Math.max(0, height - containerHeight)

  return {
    width,
    height,
    left: -overflowX * clampPosterUnit(focalPointX),
    top: -overflowY * clampPosterUnit(focalPointY),
  } as const
}
